export var WALL_ELEMENT_CLASSID = "egr.wcf.room:Wall";
export var AREA2D_ELEMENT_CLASSID = "egr.wcf.room:Area2D";
export var MEASURE_ELEMENT_CLASSID = "egr.wcf.room:measure";
export var GROUP_ELEMENT_CLASSID = "egr.wcf.room:GroupElement";
export var RECTANGLE_ELEMENT_CLASSID = "egr.wcf.room:rectangle";
export var CIRCLE_ELEMENT_CLASSID = "egr.wcf.room:circle";
export var ROOM_ELEMENT_CLASSID = "egr.wcf.room:Element";
export var DUMMY_ELEMENT_CLASSID = "egr.wcf.room:dummy";
export var ROUTE_ELEMENT_CLASSID = "egr.wcf.room:Route";
